import { computed } from '@vue/composition-api';

/**
 * Composable for the Keyword Matches section.
 * Uses the shared Daily Digest instance to derive keyword-matched opportunities.
 *
 * @param {Object} params - Configuration
 * @param {Object} params.dailyDigest - dailyDigest ref from useDailyDigest
 * @param {Object} params.loading - loading ref from useDailyDigest
 * @returns {Object} Object containing reactive state for keyword matches section
 */
export function useKeywordMatchesSection({ dailyDigest, loading }) {
  /**
   * Filters buyer activity to include only keyword matches (Opportunity cluster type).
   * These are opportunities found through keyword matching rather than tracked clusters.
   * @returns {Array} Filtered array containing only keyword-matched opportunities
   */
  const keywordMatches = computed(() => {
    if (!dailyDigest.value || !dailyDigest.value.buyer_activity) return [];
    return dailyDigest.value.buyer_activity.filter(
      activity => activity && activity.cluster_type === 'Opportunity'
    );
  });

  /**
   * Reuse the shared loading state from the Daily Digest composable.
   */
  const loadingKeywordMatches = loading;

  return {
    keywordMatches,
    loading: loadingKeywordMatches
  };
}

